
import images from "../images/images";

function LocationInfoMessage() {
  return (
    <div className="mapOverview-infoContent"  id="location_info" >
    <img
      src={images["icon_checkpoints"]}
      className="mapOverview_icon"
      alt="checkpoints"
    />
    <div className="locationInfo-title-noInfo">
      Ready to explore? <br /> <br /> Click a checkpoint!
    </div>
    <img
      src={images["icon_quests"]}
      className="mapOverview_icon"
      alt="quests"
    />
    </div>
  );
}

export default LocationInfoMessage;